/* eslint-disable */

/** unique or primary key constraints on table "argo.material_file_upload_status" */
export enum ArgoMaterialFileUploadStatusConstraint {
  /** unique or primary key constraint on columns "status" */
  MaterialFileUploadStatusPkey = 'material_file_upload_status_pkey'
}

export enum ArgoMaterialFileUploadStatusEnum {
  Deleted = 'deleted',
  Uploaded = 'uploaded'
}

/** select columns of table "argo.material_file_upload_status" */
export enum ArgoMaterialFileUploadStatusSelectColumn {
  /** column name */
  Status = 'status'
}

/** update columns of table "argo.material_file_upload_status" */
export enum ArgoMaterialFileUploadStatusUpdateColumn {
  /** column name */
  Status = 'status'
}

